import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { MOST_INTIMATE_MOMENT_COMPATIBILITY_OPTIONS } from '@/pages/Onboarding/options/MostIntimateMomentCompatibility/MOST_INTIMATE_MOMENT_COMPATIBILITY_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenMostIntimateMoment: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'MostIntimateMoment',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const mostIntimateMoment = form.watch('most_intimate_moment');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['most_intimate_moment']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        mostIntimateMoment: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage background={'dark-solid'}>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>Which moment feels most intimate to you?</OwnAiTitle>
        <OnboardingOptionsList>
          {MOST_INTIMATE_MOMENT_COMPATIBILITY_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={mostIntimateMoment === option.id}
              control={form.control}
              option={option}
              name="most_intimate_moment"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`most-intimate-moment-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
